import React from "react"
import types from "prop-types"
import { HiddenSideTabs } from "shared/tabs"
import { tabSlugFromQueryParams } from "utils/tabHelper"
import { GROUP_GENERAL_TAB_SLUG, GROUP_MEMBERS_TAB_SLUG, GROUP_WORKFLOWS_TAB_SLUG } from "utils/tabSlugHelpers"
import GeneralTab from "./GeneralTab"
import MembersTab from "./MembersTab"
import GroupWorkflowsTab from "./GroupWorkflowsTab"

const TABS = (tabProps) => [{
  title: "General",
  slug: GROUP_GENERAL_TAB_SLUG,
  TabContent: GeneralTab,
  props: tabProps,
}, {
  title: "Members",
  slug: GROUP_MEMBERS_TAB_SLUG,
  TabContent: MembersTab,
  props: tabProps,
}, {
  title: "Workflows",
  slug: GROUP_WORKFLOWS_TAB_SLUG,
  TabContent: GroupWorkflowsTab,
  props: tabProps,
}]

const GroupTabs = ({ tabProps }) => (
  <HiddenSideTabs tabs={TABS(tabProps)} initialActiveSlug={tabSlugFromQueryParams()} />
)

GroupTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabProps: types.object.isRequired,
}

export default GroupTabs
